import { render, staticRenderFns } from "./StorePreview.vue?vue&type=template&id=54238f14&scoped=true"
import script from "./StorePreview.vue?vue&type=script&lang=js"
export * from "./StorePreview.vue?vue&type=script&lang=js"
import style0 from "./StorePreview.vue?vue&type=style&index=0&id=54238f14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54238f14",
  null
  
)

export default component.exports